import React from "react";
import { inject, observer } from "mobx-react";
import { LightButton, PrimaryButton, StickyFooterButtons } from "best-common-react";

class ParkingPassFooter extends React.Component {
  render() {
    const { parkingPassStore, authStore } = this.props.rootStore;
    return (
      <StickyFooterButtons startsOpen={authStore.userData.org.orgId === 31}>
        <PrimaryButton
          onClick={parkingPassStore.saveRequest}
          disabled={!parkingPassStore.isValidRequest || parkingPassStore.isSending || parkingPassStore.game.locked}
          id="submit-request"
        >
          Submit Request
        </PrimaryButton>
        <LightButton onClick={parkingPassStore.cancel} id="cancel">
          Cancel
        </LightButton>
      </StickyFooterButtons>
    );
  }
}

export default inject("rootStore")(observer(ParkingPassFooter));
